"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ptraceBs = exports.pshowBs = exports.pbsToHex = exports.phexByte = exports.phexDigit = void 0;
var types_1 = require("../../type_system/types.js");
var builtins_1 = require("../builtins/index.js");
var pfn_1 = require("../pfn.js");
var phoist_1 = require("../phoist.js");
var plam_1 = require("../plam.js");
var precursive_1 = require("../precursive/index.js");
var punsafeConvertType_1 = require("../punsafeConvertType/index.js");
var std_1 = require("../std/index.js");
var int_1 = require("./int.js");
exports.phexDigit = (0, phoist_1.phoist)((0, plam_1.plam)(types_1.int, types_1.bs)(function (n) {
    return (0, builtins_1.pif)(types_1.bs).$(n.lt(10))
        .then(int_1.pdigitToString.$(n))
        .else((0, std_1.pByteString)("").prepend(n.add(87)));
}));
exports.phexByte = (0, phoist_1.phoist)((0, plam_1.plam)(types_1.int, types_1.bs)(function (byte) { return exports.phexDigit.$(byte.div(16)).concat(exports.phexDigit.$(byte.mod(16))); }));
exports.pbsToHex = (0, phoist_1.phoist)((0, pfn_1.pfn)([types_1.bs], types_1.bs)(function (b) {
    return (0, precursive_1.precursive)((0, pfn_1.pfn)([
        (0, types_1.fn)([types_1.int], types_1.bs),
        types_1.int
    ], types_1.bs)(function (_self, i) {
        var self = (0, punsafeConvertType_1.punsafeConvertType)(_self, (0, types_1.fn)([types_1.int], types_1.bs));
        return (0, builtins_1.pif)(types_1.bs).$(i.gtEq(b.length))
            .then((0, std_1.pByteString)(""))
            .else(exports.phexByte.$(b.at(i))
            .concat(self.$(i.add(1))));
    })).$(0);
}));
exports.pshowBs = exports.pbsToHex;
exports.ptraceBs = (0, phoist_1.phoist)((0, plam_1.plam)(types_1.bs, types_1.bs)(function (b) { return (0, builtins_1.ptrace)(types_1.bs).$(exports.pbsToHex.$(b).utf8Decoded).$(b); }));
